import React from 'react';

/**
 * Reusable bilingual input component with English/Arabic toggle buttons
 * Supports both text input and textarea
 */
export default function BilingualInput({ 
  label, 
  fieldNameEn, 
  fieldNameAr, 
  valueEn, 
  valueAr, 
  onChange, 
  placeholder = '',
  isTextarea = false,
  required = false
}) {
  const [language, setLanguage] = React.useState('en');

  const currentValue = language === 'en' ? valueEn : valueAr;
  const currentFieldName = language === 'en' ? fieldNameEn : fieldNameAr;

  const handleChange = (e) => {
    onChange(currentFieldName, e.target.value);
  };

  return (
    <div className="input-group">
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
        <label>{label}</label>
        <div style={{display: 'flex', gap: '5px'}}>
          <button 
            type="button"
            onClick={() => setLanguage('en')}
            style={{
              padding: '5px 12px',
              backgroundColor: language === 'en' ? '#0066cc' : '#e0e0e0',
              color: language === 'en' ? 'white' : 'black',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: 'bold'
            }}
          >
            English
          </button>
          <button 
            type="button"
            onClick={() => setLanguage('ar')}
            style={{
              padding: '5px 12px',
              backgroundColor: language === 'ar' ? '#0066cc' : '#e0e0e0',
              color: language === 'ar' ? 'white' : 'black',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: 'bold'
            }}
          >
            العربية
          </button>
        </div>
      </div>
      
      {isTextarea ? (
        <textarea 
          className="custom-textarea" 
          name={currentFieldName}
          value={currentValue} 
          onChange={handleChange} 
          placeholder={placeholder}
          required={required}
        />
      ) : (
        <input 
          className="custom-input" 
          type="text"
          name={currentFieldName}
          value={currentValue} 
          onChange={handleChange} 
          placeholder={placeholder}
          required={required}
        />
      )}

      {(valueEn || valueAr) && (
        <small style={{marginTop: '8px', color: '#666', display: 'block'}}>
          <strong>Preview:</strong> {valueEn ? `EN: ${valueEn}` : ''} {valueAr ? `AR: ${valueAr}` : ''}
        </small>
      )}
    </div>
  );
}
